var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _path13, _rect, _rect2, _circle, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect3, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _circle2, _path64, _g, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect4, _rect5, _ellipse2, _path85, _path86, _path87;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 333.34 400.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e4ebf7;}.cls-2,.cls-21{fill:#fff;}.cls-2{opacity:0.62;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#fafcff;stroke:#0c6bf4;stroke-miterlimit:10;stroke-width:1.18px;}.cls-32,.cls-5{fill:#3150bc;}.cls-5{opacity:0.47;}.cls-6{fill:#bac1cc;}.cls-7{fill:#edf1f9;}.cls-8{fill:#f4d242;}.cls-9{fill:#feb19e;}.cls-10{fill:#593131;}.cls-11{fill:#754343;}.cls-12{fill:url(#linear-gradient-2);}.cls-13{fill:#9eb2ef;}.cls-14{fill:#23406d;}.cls-15{fill:#a8afba;}.cls-16{fill:url(#linear-gradient-3);}.cls-17{fill:#a1a7af;}.cls-18{fill:url(#linear-gradient-4);}.cls-19{fill:#f49d8c;}.cls-20{fill:url(#linear-gradient-5);}.cls-22{fill:#383838;}.cls-23{fill:#838689;}.cls-24{fill:url(#linear-gradient-6);}.cls-25{fill:#efa245;}.cls-26{fill:#1b3151;}.cls-27{fill:url(#linear-gradient-7);}.cls-28{fill:url(#linear-gradient-8);}.cls-29{fill:#38659b;}.cls-30{fill:url(#linear-gradient-9);}.cls-31{fill:url(#linear-gradient-10);}.cls-33{fill:#a9d0ff;}.cls-34{fill:url(#linear-gradient-11);}.cls-35{fill:#ff856a;}.cls-36{fill:#e1e7f4;}.cls-37{fill:#f8fbff;}.cls-38{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 93.07,
    y1: 181.04,
    x2: 95.82,
    y2: 154.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3855e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c7ef7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 114.15,
    y1: 224.6,
    x2: 95.25,
    y2: 202.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 241.16,
    y1: 180.52,
    x2: 238.4,
    y2: 156.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 220.38,
    y1: 223.93,
    x2: 237.57,
    y2: 204.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 106.17,
    y1: 123.7,
    x2: 121.92,
    y2: 112.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 227.29,
    y1: 121.96,
    x2: 211.73,
    y2: 112.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 149.93,
    y1: 394.34,
    x2: 142.99,
    y2: 378.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 184.3,
    y1: 382.72,
    x2: 208.53,
    y2: 382.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 131.53,
    y1: 187.08,
    x2: 119.42,
    y2: 181.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 172.65,
    y1: 224.38,
    x2: 164.78,
    y2: 133.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 155.36,
    y1: 119.74,
    x2: 149.65,
    y2: 96.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#294a7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 179,
    y1: 223.83,
    x2: 171.12,
    y2: 132.86,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3327599") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.51,188.92c-.12,1.84-.27,3.69-.46,5.5-.08.92-.19,1.83-.3,2.75h0c-1.77,15.17-5.73,29.47-12.11,42h0c-.53,1.05-1.09,2.08-1.67,3.1a83.93,83.93,0,0,1-17,21.65c-.61.56-1.23,1.1-1.85,1.62A76.92,76.92,0,0,1,284.51,278c-.91.38-1.82.74-2.75,1.09h0c-17.83,6.62-40.2,8-67.63,2H214c-.95-.2-1.89-.39-2.82-.54-25.43-4.54-44.35,5.6-64.43,15.9l-2.19,1.11c-24.21,12.34-50.51,24.17-92.23,10.45C-12,286.88,1,214.59,25.05,163c.38-.83.77-1.64,1.16-2.46A234.63,234.63,0,0,1,42.38,132,115.71,115.71,0,0,0,53,111.74c.38-.91.74-1.82,1.1-2.74C68.47,72.23,67.23,32.5,92.72,17c.65-.41,1.32-.8,2-1.16a45.24,45.24,0,0,1,12.4-4.35,45.33,45.33,0,0,1,32.47,5c.86.5,1.71,1,2.54,1.55,19.53,12.52,32.91,38.17,45.41,58.51.45.76.91,1.49,1.36,2.22,9.95,15.94,19.43,28,31.15,26.9q3.56-.35,7.18-.51l2.5-.08c20.85-.52,42.81,3.6,61.51,12.3q1.17.53,2.3,1.1c17.07,8.41,31.18,20.74,38.84,37,.34.71.66,1.43,1,2.15A67.54,67.54,0,0,1,338.51,188.92Z",
    transform: "translate(-5.33 0.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.07,81.23a53.83,53.83,0,0,1-7.49,3c-.87.27-1.74.52-2.6.73C225.77,96,190.09,42,187.1,16.49c-3-25.85,30.35-18.07,62.37-3l3,1.43,3.1,1.54C290,33.82,326.69,58,279.07,81.23Z",
    transform: "translate(-5.33 0.4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.11,281.15H214c-.95-.2-1.89-.39-2.82-.54-6.59-15.9-16.17-31.92-29.24-37.72-8.91-4-18.68-2.73-29,3.67-30.37,18.77-53.85,29.34-69.65,19.89-15.1-9-21-36.44-18.16-83.83,1.82-30-2.24-53.79-12.1-70.87.38-.91.74-1.82,1.1-2.74,10.79,17.61,15.26,42.33,13.35,73.75-2.81,46.41,2.75,73.12,17,81.65,15.64,9.37,41.55-4,67.19-19.87,11.06-6.84,21.57-8.13,31.23-3.83C197.21,247.05,207.34,264.38,214.11,281.15Z",
    transform: "translate(-5.33 0.4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.79,296.49l-2.19,1.11c-1.54-5.2-4.1-10.22-8.3-13.55-6.08-4.82-14.73-5.42-25.71-1.8-24.3,8-42.84,7.29-55.12-2.23-13.74-10.64-19.6-32.37-17.41-64.55C39.65,192,33.38,175,25.05,163c.38-.83.77-1.64,1.16-2.46,9,12.38,15.9,30.15,14.21,55.05C38.28,247,43.85,268,56.93,278.16c11.61,9,29.43,9.64,52.92,1.85,11.79-3.9,21.18-3.15,27.93,2.2C142.32,285.82,145.11,291.07,146.79,296.49Z",
    transform: "translate(-5.33 0.4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256.72,195.58c-4,30.22.56,53.73,13.53,69.89A55.66,55.66,0,0,0,284.51,278c-.91.38-1.82.74-2.75,1.09h0A58.23,58.23,0,0,1,268.44,267c-13.42-16.68-18.15-40.8-14.06-71.71,5.3-40.13,22-64.13,36.88-77.94q1.17.53,2.3,1.1C278.84,131.83,262,155.49,256.72,195.58Z",
    transform: "translate(-5.33 0.4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291,205.85c-3.41,22.94-.57,40.22,8.49,51.34a32.9,32.9,0,0,0,7.44,6.73c-.61.56-1.23,1.1-1.85,1.62a35.43,35.43,0,0,1-7.42-6.86c-9.5-11.66-12.52-29.55-9-53.18,3.59-24,18.65-41.23,43.73-50.1.34.71.66,1.43,1,2.15C308.76,166.12,294.51,182.35,291,205.85Z",
    transform: "translate(-5.33 0.4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338,194.42c-.08.92-.19,1.83-.3,2.75h0a24.17,24.17,0,0,0-11.08,10.62c-4.86,9.36-3.53,21.57-1,31.35,0,0,0,0,0,0-.53,1.05-1.09,2.08-1.67,3.1-3-10.5-5.08-24.61.59-35.55A26.86,26.86,0,0,1,338,194.42Z",
    transform: "translate(-5.33 0.4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.75,105a113.59,113.59,0,0,1-5.68,18.28c-9.58,23.23-25.45,35.43-46,35.43-.82,0-1.62,0-2.45,0-28-1.29-44-44.86-59.55-87C108.48,51,101.1,31,92.72,17c.65-.41,1.32-.8,2-1.16,8.55,14.31,15.95,34.38,23.58,55.06,15.27,41.42,31.07,84.24,57.46,85.45,33.44,1.54,46.5-30,51.48-51.21Z",
    transform: "translate(-5.33 0.4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.92,78.72a37.2,37.2,0,0,1-6.62.6,31.8,31.8,0,0,1-16-4.17c-14.44-8.25-23.4-28-26.73-58.71.86.5,1.71,1,2.54,1.55C145.53,46.9,154,65.4,167.51,73.1a30.6,30.6,0,0,0,20,3.4C188,77.26,188.47,78,188.92,78.72Z",
    transform: "translate(-5.33 0.4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.59,84.23c-.87.27-1.74.52-2.6.73-6.24-6.52-13-19.63-14.61-46a92,92,0,0,0-4.9-25.4l3,1.43a96.68,96.68,0,0,1,4.28,23.83C258.39,65.87,265.45,78.42,271.59,84.23Z",
    transform: "translate(-5.33 0.4)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 164.56,
    cy: 390.73,
    rx: 96.14,
    ry: 9.68
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55,160.4s1.68,1.15,4.69,2.89c9.86,5.74,34,18,60.51,17.84.84,0,1.68,0,2.52-.06s1.89-.08,2.84-.15c2.54-.19,5.08-.5,7.64-.93l3.32-25.47-8.79.43-2.41.12-1.43.07-23.3,1.15-35.19-11.2-5-1.61S54.1,147.88,55,160.4Z",
    transform: "translate(-5.33 0.4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55,160.4s1.68,1.15,4.69,2.89c.35-6.91,3.32-13.74,5.71-18.22l-5-1.61S54.1,147.88,55,160.4Z",
    transform: "translate(-5.33 0.4)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.74,181.08c.95,0,1.89-.08,2.84-.15,2.54-.19,5.08-.5,7.64-.93l3.32-25.47-8.79.43-2.41.12a83.63,83.63,0,0,0-1.67,8.23A88.45,88.45,0,0,0,122.74,181.08Z",
    transform: "translate(-5.33 0.4)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 50.37,
    y: 136.8,
    width: 31.89,
    height: 42.59,
    transform: "translate(-29.49 12.87) rotate(-9.09)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 45.04,
    y: 137.2,
    width: 31.89,
    height: 42.59
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 52.39,
    cy: 146.19,
    r: 3.17
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.35,155.86H55.48a.94.94,0,0,1-.94-.94h0a.94.94,0,0,1,.94-.94H73.35a.94.94,0,0,1,.94.94h0A.94.94,0,0,1,73.35,155.86Z",
    transform: "translate(-5.33 0.4)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.52,160.78h-22a.94.94,0,0,1-.94-.94h0a.94.94,0,0,1,.94-.94h22a.94.94,0,0,1,.94.94h0A.94.94,0,0,1,77.52,160.78Z",
    transform: "translate(-5.33 0.4)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.52,165.35h-22a.94.94,0,0,1-.94-.94h0a.94.94,0,0,1,.94-.94h22a.94.94,0,0,1,.94.94h0A.94.94,0,0,1,77.52,165.35Z",
    transform: "translate(-5.33 0.4)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.52,169.64h-22a.94.94,0,0,1-.94-.94h0a.94.94,0,0,1,.94-.94h22a.94.94,0,0,1,.94.94h0A.94.94,0,0,1,77.52,169.64Z",
    transform: "translate(-5.33 0.4)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M49.33,152.85s6.84-.74,7,1.13-4.13,2.36-4.13,2.36,6.3.34,6.5,1.75-6.5,2.68-6.5,2.68,5.37,0,5.49,1.33-5.39,2.3-5.39,2.3,4.23.21,4.33,1.39-6.89,3.35-8.27,2,.49-3.94-1.08-5.46a4.08,4.08,0,0,1-.69-5.07C47.51,156.15,44.55,152.89,49.33,152.85Z",
    transform: "translate(-5.33 0.4)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M88,274.89l-18.41-6.28,2.15-6.31a4.64,4.64,0,0,1,5.88-2.89l9.64,3.29a4.64,4.64,0,0,1,2.89,5.88Zm-15.31-7.8,13.78,4.7,1.36-4A2.19,2.19,0,0,0,86.5,265l-9.64-3.29a2.19,2.19,0,0,0-2.78,1.36Z",
    transform: "translate(-5.33 0.4)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M43.12,273.67H98.57a0,0,0,0,1,0,0V299.5a7.16,7.16,0,0,1-7.16,7.16H50.28a7.16,7.16,0,0,1-7.16-7.16V273.67a0,0,0,0,1,0,0Z",
    transform: "translate(92.16 -6.93) rotate(18.84)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M98.91,287.16l-25-3a6.27,6.27,0,0,1-2.49-.85L49.84,270.41a2.7,2.7,0,0,1-1.17-3.19l2.07-6.08a2.7,2.7,0,0,1,3.43-1.68l48,16.38a2.7,2.7,0,0,1,1.68,3.43l-2.07,6.08A2.7,2.7,0,0,1,98.91,287.16Z",
    transform: "translate(-5.33 0.4)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M91,252.53s3.44,9.47,1.52,10.87-5.46-3.84-6.57-1.85,2.51,5.76-2.44,6.05-9.38-3.47-8.86-8.71,4.75-8.5,4.74-10.08l1-3.28,11.37,3.84Z",
    transform: "translate(-5.33 0.4)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M78.46,248.53l13.74,4.39,2.89-6.06,0-.11,13.64-28.51,14.4-3.53,6.18-1.51,1-.25,7.34-1.8,6-1.48-7.58-25s-2.58.4-6.59,1.49c-1.43.39-3,.86-4.8,1.44l-1.39.47c-1,.33-2,.71-3,1.11-7.64,3-16.74,7.66-24.12,14.91-11,10.82-15.29,27.9-16.87,37.42,0,.13,0,.26-.06.39C78.62,245.94,78.46,248.53,78.46,248.53Z",
    transform: "translate(-5.33 0.4)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.74,187.6l-1.39.47a86.74,86.74,0,0,0,7,24.89l7.34-1.8,6-1.48-7.58-25s-2.58.4-6.59,1.49C128.11,186.54,126.49,187,124.74,187.6Z",
    transform: "translate(-5.33 0.4)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M79.28,241.9c-.66,4-.83,6.63-.83,6.63l13.74,4.39,2.89-6.06,0-.11A58,58,0,0,1,79.28,241.9Z",
    transform: "translate(-5.33 0.4)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 285.86,
    y: 127.3,
    width: 17.57,
    height: 32.34,
    rx: 2.36,
    ry: 2.36,
    transform: "translate(-28.35 63.31) rotate(-11.73)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M289.35,129.67h9.9a1.64,1.64,0,0,1,1.64,1.64v22.61a0,0,0,0,1,0,0H287.71a0,0,0,0,1,0,0V131.31A1.64,1.64,0,0,1,289.35,129.67Z",
    transform: "matrix(0.98, -0.2, 0.2, 0.98, -28.01, 63.2)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M278,156.67l3.17-1.1s2.64,1.39,6.86-.56l-2.56-12.32s4.41-3.07,4.34-4.91-8.71-1.4-12.18,7l-3.84,1.62Z",
    transform: "translate(-5.33 0.4)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M279,160.4s-1.68,1.15-4.69,2.89c-9.86,5.74-34,18-60.51,17.84-.84,0-1.68,0-2.52-.06s-1.89-.08-2.84-.15c-2.54-.19-5.08-.5-7.64-.93l-3.32-25.47,8.79.43,2.41.12,1.43.07,23.3,1.15,35.19-11.2,5-1.61S279.91,147.88,279,160.4Z",
    transform: "translate(-5.33 0.4)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M211.27,181.08c-.94,0-1.89-.08-2.84-.15-2.54-.19-5.08-.5-7.64-.93l-3.32-25.47,8.79.43,2.41.12a83.6,83.6,0,0,1,1.67,8.23A88.44,88.44,0,0,1,211.27,181.08Z",
    transform: "translate(-5.33 0.4)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M273.62,143.47l-5,1.61c2.39,4.48,5.35,11.31,5.71,18.22,3-1.75,4.69-2.89,4.69-2.89C279.91,147.88,273.62,143.47,273.62,143.47Z",
    transform: "translate(-5.33 0.4)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M259.08,258.64h0a1.53,1.53,0,0,1-.81,2L242.2,267.5l-1.2-2.81,16.07-6.85A1.53,1.53,0,0,1,259.08,258.64Z",
    transform: "translate(-5.33 0.4)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222,274.42A11,11,0,1,0,227.86,260,11,11,0,0,0,222,274.42Zm18.29-7.8A8.86,8.86,0,1,1,228.71,262,8.86,8.86,0,0,1,240.33,266.63Z",
    transform: "translate(-5.33 0.4)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.84,250.86l1.1,3.32a46.23,46.23,0,0,1,.13,5.46c-.16,1.82-1.51,4.89.27,5.33s1.39,4.32,5.23,3.44,9.64-4.37,9.49-7.49-4.71-8.74-4.71-8.74l-.67-3Z",
    transform: "translate(-5.33 0.4)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M255.55,248.53l-13.74,4.39-2.89-6.06,0-.11-13.64-28.51-14.4-3.53-6.18-1.51-1-.25-7.34-1.8-6-1.48,7.58-25s2.58.4,6.59,1.49c1.43.39,3,.86,4.8,1.44l1.39.47c1,.33,2,.71,3,1.11,7.64,3,16.74,7.66,24.12,14.91,11,10.82,15.29,27.9,16.87,37.42,0,.13,0,.26.06.39C255.39,245.94,255.55,248.53,255.55,248.53Z",
    transform: "translate(-5.33 0.4)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M209.27,187.6l1.39.47a86.74,86.74,0,0,1-7,24.89l-7.34-1.8-6-1.48,7.58-25s2.58.4,6.59,1.49C205.9,186.54,207.52,187,209.27,187.6Z",
    transform: "translate(-5.33 0.4)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M238.87,246.76l0,.11,2.89,6.06,13.74-4.39s-.17-2.59-.83-6.63A58,58,0,0,1,238.87,246.76Z",
    transform: "translate(-5.33 0.4)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M120.25,66.78s-6.07-2.67-6.58-4.9-1.36-7.36-3.1-7.7-.73,7.92-.73,7.92-.47-7.85-2.81-8.68-.39,9.71-.63,9.36-1.36-8-2.61-7.83-1.68,7.79.09,11.53a30.17,30.17,0,0,1,2.34,7.07l11,.73Z",
    transform: "translate(-5.33 0.4)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118,74.24a16.7,16.7,0,0,0,6.86-10.69c1-5-3.68-.74-5.22,2.82,0,0-8-.48-9.38,7.33Z",
    transform: "translate(-5.33 0.4)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M106.74,121.06c5.27,11,14,19.42,20.82,24.84l.44.34.17.13a78.48,78.48,0,0,0,9.56,6.47l15.62-21-5.16-3.43-2.27-1.51-1.32-.87L123.36,112l-3.18-31.57-.67-6.66-14.42-.53s-.76,2.65-1.54,6.91C101.81,89.64,100.05,107.15,106.74,121.06Z",
    transform: "translate(-5.33 0.4)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.71,152.85l15.62-21-5.16-3.43-2.27-1.51-1.32-.87c-4.51,2.53-11.49,8.19-16.42,20.31A78.48,78.48,0,0,0,137.71,152.85Z",
    transform: "translate(-5.33 0.4)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M103.54,80.14a80.64,80.64,0,0,1,16.63.29l-.67-6.67-14.42-.53S104.32,75.88,103.54,80.14Z",
    transform: "translate(-5.33 0.4)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124,30.38a8.82,8.82,0,1,0-15.06,6.23,10,10,0,0,1,2.59,4.45l.71,2.63H118l.67-2.49a10,10,0,0,1,2.67-4.53A8.79,8.79,0,0,0,124,30.38Z",
    transform: "translate(-5.33 0.4)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M113.13,32.37a1.15,1.15,0,1,0,.66,2.09v9.22h.49V33.52A1.15,1.15,0,0,0,113.13,32.37Zm0,1.81a.66.66,0,1,1,.66-.66A.66.66,0,0,1,113.13,34.18Z",
    transform: "translate(-5.33 0.4)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M116.55,33.37a1.15,1.15,0,0,0-1.15,1.15l-.06,9.16h.49l.06-8.22a1.15,1.15,0,1,0,.66-2.09Zm0,1.81a.66.66,0,1,1,.66-.66A.66.66,0,0,1,116.55,35.18Z",
    transform: "translate(-5.33 0.4)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M115.1,47h0a3,3,0,0,1-3-3v-.7h6V44A3,3,0,0,1,115.1,47Z",
    transform: "translate(-5.33 0.4)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M118.13,44.68h-6.07a.23.23,0,0,1-.23-.23h0a.23.23,0,0,1,.23-.23h6.07a.23.23,0,0,1,.23.23h0A.23.23,0,0,1,118.13,44.68Z",
    transform: "translate(-5.33 0.4)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M118.17,45.66H112.1a.23.23,0,0,1-.23-.23h0a.23.23,0,0,1,.23-.23h6.07a.23.23,0,0,1,.23.23h0A.23.23,0,0,1,118.17,45.66Z",
    transform: "translate(-5.33 0.4)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M104.43,30h-2.31a.45.45,0,0,1-.45-.45h0a.45.45,0,0,1,.45-.45h2.31a.45.45,0,0,1,.45.45h0A.45.45,0,0,1,104.43,30Z",
    transform: "translate(-5.33 0.4)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M105.14,25.84l-2.05-1.07a.45.45,0,0,1-.19-.6h0a.45.45,0,0,1,.6-.19l2.05,1.07a.45.45,0,0,1,.19.6h0A.45.45,0,0,1,105.14,25.84Z",
    transform: "translate(-5.33 0.4)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M105.29,33.18l-2.05,1.07a.45.45,0,0,0-.19.6h0a.45.45,0,0,0,.6.19L105.7,34a.45.45,0,0,0,.19-.6h0A.45.45,0,0,0,105.29,33.18Z",
    transform: "translate(-5.33 0.4)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M107.64,22.41,106,20.77a.44.44,0,0,1,0-.63h0a.45.45,0,0,1,.63,0l1.64,1.64a.45.45,0,0,1,0,.63h0A.45.45,0,0,1,107.64,22.41Z",
    transform: "translate(-5.33 0.4)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M110.47,20.23l-.8-2.17a.45.45,0,0,1,.26-.57h0a.45.45,0,0,1,.57.26l.8,2.17a.45.45,0,0,1-.26.57h0A.45.45,0,0,1,110.47,20.23Z",
    transform: "translate(-5.33 0.4)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.93,29.69h2.31a.45.45,0,0,0,.45-.45h0a.45.45,0,0,0-.45-.45h-2.31a.45.45,0,0,0-.45.45h0A.45.45,0,0,0,125.93,29.69Z",
    transform: "translate(-5.33 0.4)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.22,25.55l2.05-1.07a.45.45,0,0,0,.19-.6h0a.45.45,0,0,0-.6-.19l-2.05,1.07a.45.45,0,0,0-.19.6h0A.45.45,0,0,0,125.22,25.55Z",
    transform: "translate(-5.33 0.4)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.08,32.89,127.13,34a.45.45,0,0,1,.19.6h0a.45.45,0,0,1-.6.19l-2.05-1.07a.45.45,0,0,1-.19-.6h0A.45.45,0,0,1,125.08,32.89Z",
    transform: "translate(-5.33 0.4)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122.73,22.11l1.64-1.64a.44.44,0,0,0,0-.63h0a.44.44,0,0,0-.63,0l-1.64,1.64a.45.45,0,0,0,0,.63h0A.45.45,0,0,0,122.73,22.11Z",
    transform: "translate(-5.33 0.4)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M119.89,19.94l.8-2.17a.45.45,0,0,0-.26-.57h0a.45.45,0,0,0-.57.26l-.8,2.17a.45.45,0,0,0,.26.57h0A.45.45,0,0,0,119.89,19.94Z",
    transform: "translate(-5.33 0.4)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.69,19.25V16.93a.45.45,0,0,1,.45-.45h0a.45.45,0,0,1,.45.45v2.31a.45.45,0,0,1-.45.45h0A.45.45,0,0,1,114.69,19.25Z",
    transform: "translate(-5.33 0.4)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M214,66.48s6.07-2.67,6.58-4.9,1.36-7.36,3.1-7.7.73,7.92.73,7.92.47-7.85,2.81-8.68.39,9.71.63,9.36,1.36-8,2.61-7.83,1.68,7.79-.09,11.53a30.17,30.17,0,0,0-2.34,7.07l-11,.73Z",
    transform: "translate(-5.33 0.4)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M216.33,73.94a16.7,16.7,0,0,1-6.86-10.69c-1-5,3.68-.74,5.22,2.82,0,0,8-.48,9.38,7.33Z",
    transform: "translate(-5.33 0.4)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M227.27,121.06c-5.27,11-14,19.42-20.82,24.84l-.44.34-.17.13a78.48,78.48,0,0,1-9.56,6.47l-15.62-21,5.16-3.43,2.27-1.51,1.32-.87L210.65,112l3.18-31.57.67-6.66,14.42-.53s.76,2.65,1.54,6.91C232.2,89.64,234,107.15,227.27,121.06Z",
    transform: "translate(-5.33 0.4)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.3,152.85l-15.62-21,5.16-3.43,2.27-1.51,1.32-.87c4.51,2.53,11.49,8.19,16.42,20.31A78.48,78.48,0,0,1,196.3,152.85Z",
    transform: "translate(-5.33 0.4)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M214.5,73.76l-.67,6.67a80.64,80.64,0,0,1,16.63-.29c-.78-4.26-1.54-6.91-1.54-6.91Z",
    transform: "translate(-5.33 0.4)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 211.37,
    cy: 33.78,
    r: 9.52
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M216.7,22.67A10.71,10.71,0,1,0,227.4,33.37,10.71,10.71,0,0,0,216.7,22.67Zm0,19.6a8.89,8.89,0,0,1-8.9-8.9,8.89,8.89,0,0,1,6.25-8.5,8.9,8.9,0,1,1,2.64,17.39Z",
    transform: "translate(-5.33 0.4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    className: "cls-8",
    d: "M217.41,32.7V30.12c1.22.21,1.22,1,1.22,1.24h1.43a2.65,2.65,0,0,0-2.65-2.69v-1H216v1A2.69,2.69,0,0,0,216,34v2.58c-1.22-.21-1.22-1-1.22-1.24h-1.43A2.65,2.65,0,0,0,216,38.08v1h1.43v-1a2.69,2.69,0,0,0,0-5.38Zm-2.65-1.34c0-.28,0-1,1.22-1.24V32.6C214.76,32.39,214.76,31.63,214.76,31.36Zm2.65,5.27V34.15c1.22.21,1.22,1,1.22,1.24S218.63,36.42,217.41,36.63Z",
    transform: "translate(-5.33 0.4)"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M166.62,374H144.18s-6.41-79.15-4.13-148.26H168.4l4.16,59.89S167.21,343.59,166.62,374Z",
    transform: "translate(-5.33 0.4)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M161.43,374.05c-2.52-35.38,4.7-109,4.77-109.73l1.18.12c-.07.74-7.28,74.25-4.77,109.53Z",
    transform: "translate(-5.33 0.4)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M166,387.49a7.16,7.16,0,0,1-.3,2.67c-1.09,2.16-37.71,1.67-39.87,1.57-1.89-.08-1.61-6.12,7.28-9.59a30.28,30.28,0,0,1,4.44-1.33c8.86-2,8.56-6.79,8.56-6.79l18.41,0A124.42,124.42,0,0,1,166,387.49Z",
    transform: "translate(-5.33 0.4)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M166,387.49a7.16,7.16,0,0,1-.3,2.67c-1.09,2.16-37.71,1.67-39.87,1.57-1.89-.08-1.61-6.12,7.28-9.59,2.16.41,4.49,2.1,5.42,7.09C138.57,389.23,157.61,389.44,166,387.49Z",
    transform: "translate(-5.33 0.4)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M207.24,390.1c-2.78,1.23-12.29,1.61-17.92,1a10,10,0,0,1-3.93-1c-2.52-1.77.14-16,.14-16h13.59s-.3,5.27,3.26,6.9a12.77,12.77,0,0,1,3.58,2.66l.2.21a10.29,10.29,0,0,1,1.2,1.46C208.73,387.25,209.15,389.26,207.24,390.1Z",
    transform: "translate(-5.33 0.4)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M207.24,390.1c-2.78,1.23-12.29,1.61-17.92,1-.59-7,5.17-10.42,9.93-10.42a9.63,9.63,0,0,1,6.7,3l.2.21a10.29,10.29,0,0,1,1.2,1.46C208.73,387.25,209.15,389.26,207.24,390.1Z",
    transform: "translate(-5.33 0.4)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M162,228.59,181.39,374h21L197.93,247.9a133,133,0,0,0,1.38-22.15Z",
    transform: "translate(-5.33 0.4)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M197.16,374,196,374c1.38-40.64-5.64-124.9-5.71-125.74,1.17-12.81-.65-19.65-.67-19.72l1.14-.31c.08.28,1.9,7.09.71,20C191.52,249,198.54,333.32,197.16,374Z",
    transform: "translate(-5.33 0.4)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M134.09,193.27s-4.24,11.81-14.87,5.61,1.65-33.53,1.65-33.53Z",
    transform: "translate(-5.33 0.4)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.42,159.52s-1-3.47,4-4.5,7.16,2.14,8.49,5.17Z",
    transform: "translate(-5.33 0.4)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M200.13,183c-3.83,9.52-3.56,11.53-3.56,11.53l2.74,31.21s-44.78,15.06-59.27,0l-1.42-25.19-.72-12.82-.14-.69-5.65-27.18,5.79.31c-1-2.28-2.48-4.67-5.3-5.25,1.82-4.56,6-14,11.08-17.65,6.77-4.94,20.72-10.92,41.11-5.09S203.94,173.49,200.13,183Z",
    transform: "translate(-5.33 0.4)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M196.57,194.54s-.61,16.65-15.77,21.17-27.27-13.59-29.83-15c-2.13-1.19-9.78-.41-12.34-.11l-.72-12.82-.14-.69,12.78-2.4,19.34,18.25Z",
    transform: "translate(-5.33 0.4)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M183.16,164.52s-16.23,5-38.59,0v22.1s24.41,5.17,42.53,0Z",
    transform: "translate(-5.33 0.4)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M187.1,150.77S175.95,193.71,157.5,180l-5.17,5.75,25.74,16Z",
    transform: "translate(-5.33 0.4)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M172.41,125.63s5.74-8.56,3.3-18.3-7.9-7.53-7.9-7.53,4-6.35-2.81-9.45-11.57-.59-6.76,1.18c0,0-9.92,0-15.68,6.2s-9.89-.15-11.52,1.18,1.4,5.62,4,6.05c0,0-6.2-1.33-6.64,0s3.51,9.74,12.52,9.59c0,0-1.15,5.45,8,11.07S172.41,125.63,172.41,125.63Z",
    transform: "translate(-5.33 0.4)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M175.71,133.31a27.23,27.23,0,0,1-1.07,3.06c-1.71,4.1-5.56,10.86-12.37,10.6-2.33-.08-3.1-2-3.33-4.54-.34-3.41.27-7.82-.8-9.86l6.62-8.52,4.39-5.66.74-1A78.75,78.75,0,0,0,175.71,133.31Z",
    transform: "translate(-5.33 0.4)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M174.63,136.37c-1.71,4.1-5.56,10.86-12.37,10.6-2.33-.08-3.1-2-3.33-4.54-.34-3.41.27-7.82-.8-9.86l6.62-8.52,5-1.75s-.14,10.07-8.09,16.39c0,0,4.06,1.44,9.47-4C172.3,133.55,173.48,134.57,174.63,136.37Z",
    transform: "translate(-5.33 0.4)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M173,127.17l.72,1.79s-2.29,9.45-10.27,12.25l.75,9s11.72-5.68,13.86-18C178.07,132.21,175.74,127,173,127.17Z",
    transform: "translate(-5.33 0.4)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M160.27,140.81l-1,9.29s-7-5-4.67-15.41c0,0,2.65,1.63,4.64,1.26C159.26,135.95,158.28,137.78,160.27,140.81Z",
    transform: "translate(-5.33 0.4)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M143.69,113.82c2.09,8.9,4.56,17.44,11.93,21.45a6,6,0,0,0,6-.16c3.57-2.2,9-7.25,8.27-17.35,0,0,2.44.89,2.84-3.94s-1.26-5.66-3.05-5.27-1.62,6.84-1.62,6.84-6.3-1.35-7.7-9.77c0,0-2.66,3.77-4.95,4.73S154,107,154,107,152.35,113.16,143.69,113.82Z",
    transform: "translate(-5.33 0.4)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 122.79,
    y: 158.5,
    width: 24.81,
    height: 35.73,
    rx: 2.81,
    ry: 2.81,
    transform: "matrix(1, -0.07, 0.07, 1, -17.47, 10.41)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 121.69,
    y: 158.5,
    width: 24.81,
    height: 35.73,
    rx: 2.81,
    ry: 2.81,
    transform: "translate(-17.47 10.33) rotate(-4.06)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 133.21,
    cy: 176.5,
    rx: 2.61,
    ry: 3.81,
    transform: "translate(-17.48 10.27) rotate(-4.06)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M154.19,178.61s-1.23-7.72-7-8v3.11s-3.75.89-6-1.7-4.73-4.55-4.13,2.6,5.61,10.62,11,10.25l2.07,1.77,5.91-6Z",
    transform: "translate(-5.33 0.4)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M183.36,210.4c-13.85,5.34-26.41-9.6-32.16-18-2.1-3.06-3.28-5.25-3.28-5.25l8.46-8.07,4.74,3.85,14.59,11.9s2.53-11.61,4.7-25.2,5.72-22.16,13.18-21.06C208.36,150.74,202.26,203.11,183.36,210.4Z",
    transform: "translate(-5.33 0.4)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M161.12,182.94a30.17,30.17,0,0,1-9.91,9.46c-2.1-3.06-3.28-5.25-3.28-5.25l8.46-8.07Z",
    transform: "translate(-5.33 0.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.bcb75c94ab5c30b067284d994b3655ae.svg";
export { ForwardRef as ReactComponent };